// Copyright (c) 2016 Deere & Company

import Criteria, {getDefaultState} from '../../update-machine-status-history/state/criteria';
import actions from '../../actions-list';

const updateMachineStatusHistoryToDisplay = (state, action) =>
    Criteria.update(state, {
        historyToDisplay: {
            $set: action.historyToDisplay
        }
    });

const resetMachineStatusHistoryToDisplay = state =>
    Criteria.update(state, {
        historyToDisplay: {
            $set: null
        }
    });

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.UPDATE_MACHINE_STATUS_HISTORY_TO_DISPLAY]: updateMachineStatusHistoryToDisplay,
        [actions.RESET_MACHINE_STATUS_HISTORY_TO_DISPLAY]: resetMachineStatusHistoryToDisplay
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/reports/update-machine-status-history/reducers/criteria.js